import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer aussi l'enum GoogleReserveStatus dans le fichier prisma
// (dual-defined, mêmes valeurs et même ordre — cf. google-feed-merge-v1-v2-plan.md §5.4).
export enum GoogleReserveStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DISABLED = 'DISABLED',
}

export const GOOGLE_RESERVE_STATUS_TRANSLATE_KEY = 'GOOGLE_RESERVE_STATUS_';

export const GoogleReserveStatusTranslation = {
  'fr-FR': {
    [`${GOOGLE_RESERVE_STATUS_TRANSLATE_KEY}${GoogleReserveStatus.NOT_REQUESTED}`]: 'Non demandé',
    [`${GOOGLE_RESERVE_STATUS_TRANSLATE_KEY}${GoogleReserveStatus.PENDING_REVIEW}`]: 'En cours de revue',
    [`${GOOGLE_RESERVE_STATUS_TRANSLATE_KEY}${GoogleReserveStatus.APPROVED}`]: 'Activé',
    [`${GOOGLE_RESERVE_STATUS_TRANSLATE_KEY}${GoogleReserveStatus.REJECTED}`]: 'Refusé',
    [`${GOOGLE_RESERVE_STATUS_TRANSLATE_KEY}${GoogleReserveStatus.DISABLED}`]: 'Désactivé',
  },
};

//⚠️IMPACT attention changer aussi l'enum GoogleFeedRunStatus dans le fichier prisma
export enum GoogleFeedRunStatus {
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export const GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY = 'GOOGLE_FEED_RUN_STATUS_';

export const GoogleFeedRunStatusTranslation = {
  'fr-FR': {
    [`${GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY}${GoogleFeedRunStatus.RUNNING}`]: 'En cours',
    [`${GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY}${GoogleFeedRunStatus.SUCCESS}`]: 'Succès',
    [`${GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY}${GoogleFeedRunStatus.FAILED}`]: 'Échec',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  GoogleReserveStatus,
  GoogleReserveStatusTranslation,
  GOOGLE_RESERVE_STATUS_TRANSLATE_KEY,
  true,
);
validateEnumTranslations(
  GoogleFeedRunStatus,
  GoogleFeedRunStatusTranslation,
  GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY,
  true,
);
